// import React, { useCallback, useEffect, useState } from 'react';
// import {
//   Grid,
//   Card,
//   CardContent,
//   Typography,
//   CircularProgress,
//   Box,
//   Pagination,
//   Container,
//   useMediaQuery,
//   useTheme,
//   Tabs,
//   Tab,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Alert,
//   Button,
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import axios from 'axios';
// import { BACKEND_BASE_URL } from '../config';

// function requestErrorMessage(error, fallback = 'Request failed.') {
//   const status = error?.response?.status;
//   if (status === 504) {
//     return 'Gateway timeout: the server did not respond in time. The query may still be running; wait a minute and try Retry, or ensure the API has caching enabled for this endpoint.';
//   }
//   if (status) {
//     return `Request failed (HTTP ${status}).`;
//   }
//   const msg = String(error?.message || '');
//   if (msg.includes('504') || /gateway\s*time-?out/i.test(msg)) {
//     return 'Gateway timeout: the proxy closed the connection before the API finished (often ~60s). Retry after deploying query fixes, or raise proxy_read_timeout for the API.';
//   }
//   if (error?.code === 'ECONNABORTED') {
//     return 'Request aborted due to a client timeout. Try again or increase the HTTP client timeout.';
//   }
//   return fallback;
// }





// const CustomAccordion = ({ title, children, defaultOpen = true, sx }) => {
//   const [open, setOpen] = useState(defaultOpen);

//   return (
//     <Accordion
//       expanded={open}
//       onChange={() => setOpen(!open)}
//       disableGutters
//       elevation={3}
//       sx={{
//         ...sx,
//         transition: 'none',
//         '&.Mui-expanded': {
//           marginBottom: 0, // Only override bottom margin
//         },
//       }}
//     >
//       <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//         <Typography variant="h6" fontWeight="bold">{title}</Typography>
//       </AccordionSummary>
//       <AccordionDetails
//         sx={{
//           transition: 'none',
//           visibility: open ? 'visible' : 'hidden',
//           height: open ? 'auto' : 0,
//           overflow: 'hidden',
//           padding: open ? 2 : 0,
//         }}
//       >
//         {children}
//       </AccordionDetails>
//     </Accordion>
//   );
// };



// const StatsPage = () => {
//   const [stats, setStats] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [count, setCount] = useState(0);
//   const [tabIndex, setTabIndex] = useState(0);
//   const [townsWithoutData, setTownsWithoutData] = useState(null);
//   const [loadingErrors, setLoadingErrors] = useState(false);
//   const [townsWithOldData, setTownsWithOldData] = useState(null);
//   const [statsError, setStatsError] = useState(null);
//   const [contentErrorsError, setContentErrorsError] = useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const itemsPerPage = 15;

//   const fetchStats = useCallback(async (pageNum = 1) => {
//     try {
//       setLoading(true);
//       setStatsError(null);
//       const res = await axios.get(`${BACKEND_BASE_URL}/api/municipality/stats/?page=${pageNum}`);
//       setStats(res.data);
//       setCount(res.data?.count || 1);
//     } catch (error) {
//       console.error('Error fetching stats:', error);
//       setStats(null);
//       setStatsError(requestErrorMessage(error));
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   const fetchContentErrors = useCallback(async () => {
//     try {
//       setLoadingErrors(true);
//       setContentErrorsError(null);
//       setTownsWithoutData(null);
//       setTownsWithOldData(null);
//       const res = await axios.get(`${BACKEND_BASE_URL}/api/content-error/`);
//       setTownsWithoutData(res.data?.towns_without_data || {});
//       setTownsWithOldData(
//         res.data?.towns_with_old_data ?? { count: 0, entries: [] }
//       );
//     } catch (err) {
//       console.error('Error fetching towns without data:', err);
//       setContentErrorsError(requestErrorMessage(err));
//       setTownsWithoutData({ count: 0, entries: [] });
//       setTownsWithOldData({ count: 0, entries: [] });
//     } finally {
//       setLoadingErrors(false);
//     }
//   }, []);

//   useEffect(() => {
//     if (tabIndex !== 0) return;
//     fetchStats(page);
//   }, [tabIndex, page, fetchStats]);

//   useEffect(() => {
//     if (tabIndex !== 1) return;
//     fetchContentErrors();
//   }, [tabIndex, fetchContentErrors]);

//   const handlePageChange = (_, value) => {
//     setPage(value);
//   };

//   const handleTabChange = (_, newValue) => {
//     setTabIndex(newValue);
//   };


//   const overall = stats?.results?.overall || {};
//   const stateStats = stats?.results?.by_state || [];

//   return (
//     <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 5 } }}>
//       <Tabs
//         value={tabIndex}
//         onChange={handleTabChange}
//         variant="scrollable"
//         scrollButtons="auto"
//         textColor="primary"
//         indicatorColor="primary"
//         sx={{ mb: 4 }}
//       >
//         <Tab label={<Typography variant={isMobile ? "body1" : "h6"} fontWeight="bold">📊 Stats</Typography>} />
//         <Tab label={<Typography variant={isMobile ? "body1" : "h6"} fontWeight="bold">❌ Content Errors</Typography>} />
//       </Tabs>

//       {/* 📊 Stats Tab */}
//       {tabIndex === 0 && (
//         <>
//           {loading ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
//               <CircularProgress size={50} />
//             </Box>
//           ) : statsError && !stats ? (
//             <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2 }}>
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {statsError}
//               </Alert>
//               <Button variant="contained" onClick={() => fetchStats(page)}>
//                 Retry
//               </Button>
//             </Box>
//           ) : !stats ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
//               <CircularProgress size={50} />
//             </Box>
//           ) : (
//             <>
//               <Card elevation={3} sx={{ borderRadius: 4, mb: 4 }}>
//                 <CardContent>
//                   <Typography
//                     variant="h5"
//                     fontWeight="medium"
//                     sx={{ fontSize: { xs: '1.3rem', sm: '1.5rem' } }}
//                   >
//                     👤 User Count: {(overall.total_users ?? 0).toLocaleString()}
//                   </Typography>
//                 </CardContent>
//               </Card>

//               <Card elevation={3} sx={{ borderRadius: 4, mb: 4 }}>
//                 <CardContent>
//                   <Typography
//                     variant="h5"
//                     fontWeight="medium"
//                     sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' }, mb: 2 }}
//                   >
//                     🌍 User Breakdown by Country
//                   </Typography>

//                   <Grid container spacing={2}>
//                     {stats?.results?.country_breakdown?.map((country, index) => (
//                       <Grid item xs={12} sm={6} md={4} key={index}>
//                         <Typography variant="body1">
//                           {country.name}: <strong>{country.user_count.toLocaleString()}</strong>
//                         </Typography>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </CardContent>
//               </Card>


//               <Typography variant="h5" fontWeight="bold" gutterBottom>
//                 📦 Platform Totals:
//               </Typography>

//               <Card elevation={3} sx={{ borderRadius: 4, mb: 5 }}>
//                 <CardContent>
//                   <Grid container spacing={2}>
//                     {[
//                       { label: '🏙️ Total towns', value: overall.total_towns },
//                       { label: '🏞️ Total counties', value: overall.total_counties },
//                       { label: '🏛️ Total Town Governments', value: overall.total_town_governments },
//                       { label: '🏫 Total School Boards', value: overall.total_school_boards },
//                       { label: '🏛️ Total town meetings', value: overall.total_town_meetings },
//                       { label: '🏫 Total BoE meetings', value: overall.total_boe_meetings },
//                       { label: '👥 Total population', value: overall.total_population }
//                     ].map((item, i) => (
//                       <Grid item xs={12} sm={6} key={i}>
//                         <Typography>
//                           {item.label}: {(item.value ?? 0).toLocaleString()}
//                         </Typography>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </CardContent>
//               </Card>

//               <Typography variant="h5" fontWeight="bold" gutterBottom>
//                 🗺️ Breakdown by State/Country:
//               </Typography>

//               <Grid container spacing={2}>
//                 {stateStats.map((state, index) => (
//                   <Grid item xs={12} sm={6} md={4} key={index}>
//                     <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
//                       <CardContent>
//                         <Typography variant="h6" fontWeight="bold" gutterBottom>
//                           {state.state}
//                         </Typography>
//                         <Typography>Towns: {(state.total_towns ?? 0).toLocaleString()}</Typography>
//                         <Typography>Counties: {(state.total_counties ?? 0).toLocaleString()}</Typography>
//                         <Typography>Town Governments: {(state.total_town_governments ?? 0).toLocaleString()}</Typography>
//                         <Typography>School Boards: {(state.total_school_boards ?? 0).toLocaleString()}</Typography>
//                         <Typography>Town Meetings: {(state.total_town_meetings ?? 0).toLocaleString()}</Typography>
//                         <Typography>BOE Meetings: {(state.total_boe_meetings ?? 0).toLocaleString()}</Typography>
//                         <Typography>Population: {(state.total_population ?? 0).toLocaleString()}</Typography>
//                       </CardContent>
//                     </Card>

//                   </Grid>
//                 ))}
//               </Grid>

//               <Box mt={4} display="flex" justifyContent="center">
//                 <Pagination
//                   count={Math.ceil(count / itemsPerPage)}
//                   page={page}
//                   onChange={handlePageChange}
//                   color="primary"
//                   shape="rounded"
//                   size={isMobile ? 'medium' : 'large'}
//                 />
//               </Box>
//             </>
//           )}
//         </>
//       )}

//       {/* ❌ Content Errors Tab */}
//       {tabIndex === 1 && (
//         <>
//           {loadingErrors || townsWithoutData === null ? (
//             <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
//               <CircularProgress size={50} />
//             </Box>
//           ) : contentErrorsError ? (
//             <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2 }}>
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {contentErrorsError}
//               </Alert>
//               <Button variant="contained" onClick={() => fetchContentErrors()}>
//                 Retry
//               </Button>
//             </Box>
//           ) : (
//             <>
//               <CustomAccordion title={`❗ Towns Without Data (${townsWithoutData?.count || 0})`}>
//                 {townsWithoutData?.entries?.map((entry) => (
//                   <Box key={entry.id} sx={{ mb: 2 }}>
//                     <Typography
//                       variant="body1"
//                       fontWeight="medium"
//                       sx={{ cursor: 'pointer' }}
//                       onClick={() => {
//                         sessionStorage.setItem('channel_urls', JSON.stringify([entry.channel_url]));
//                         sessionStorage.setItem('state', entry.state);
//                         sessionStorage.setItem('county', entry.county);
//                         window.open(`/app/manage?search=${encodeURIComponent(entry.name)}`, '_blank');
//                       }}
//                     >
//                       {entry.name}, {entry.county}, {entry.state}, ({entry.id})
//                     </Typography>

//                     <Box sx={{ ml: 2, mt: 1 }}>
//                       <Typography variant="body2">Channel:</Typography>
//                       <a
//                         href={entry.channel_url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         style={{ wordBreak: 'break-word' }}
//                       >
//                         {entry.channel_url}
//                       </a>
//                     </Box>
//                   </Box>
//                 ))}
//               </CustomAccordion>

//               <CustomAccordion
//                 title={`🕒 Towns With Data Older Than 60 Days (${townsWithOldData?.count || 0})`}
//                 sx={{ mt: 3 }}
//               >
//                 {townsWithOldData?.entries?.map((entry) => (
//                   <Box key={entry.id} sx={{ mb: 2 }}>
//                     <Typography
//                       variant="body1"
//                       fontWeight="medium"
//                       sx={{ cursor: 'pointer' }}
//                       onClick={() => {
//                         sessionStorage.setItem('channel_urls', JSON.stringify([entry.channel_url]));
//                         sessionStorage.setItem('state', entry.state);
//                         sessionStorage.setItem('county', entry.county);
//                         window.open(`/app/manage?search=${encodeURIComponent(entry.name)}`, '_blank');
//                       }}
//                     >
//                       {entry.name}, {entry.county}, {entry.state}, ({entry.id})
//                     </Typography>

//                     <Box sx={{ ml: 2, mt: 1 }}>
//                       <Typography variant="body2">Channel:</Typography>
//                       <a
//                         href={entry.channel_url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         style={{ wordBreak: 'break-word' }}
//                       >
//                         {entry.channel_url}
//                       </a>
//                     </Box>
//                   </Box>
//                 ))}
//               </CustomAccordion>


//             </>
//           )}
//         </>
//       )}
//     </Container>
//   );
// };

// export default StatsPage;

import React, { useEffect, useState } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Box,
  Pagination,
  Container,
  useMediaQuery,
  useTheme,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails

} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import { BACKEND_BASE_URL } from '../config';

const STATS_CACHE_TTL_MS = 15 * 60 * 1000;
const STATS_PREFETCH_PAGE1_KEY = 'admin_stats_page_1_cache_v1';
const CONTENT_ERRORS_CACHE_KEY = 'admin_content_errors_cache_v1';

function getCachePayload(storageKey) {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.fetchedAt !== 'number') return null;
    if (Date.now() - parsed.fetchedAt > STATS_CACHE_TTL_MS) return null;
    return parsed.data;
  } catch {
    return null;
  }
}

function setCachePayload(storageKey, data) {
  try {
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({ fetchedAt: Date.now(), data }),
    );
  } catch {
    // Ignore storage failures; page still works with live fetches.
  }
}

function normalizeOldData(rawOldData) {
  return rawOldData && typeof rawOldData === 'object'
    ? {
        count: rawOldData.count ?? 0,
        entries: Array.isArray(rawOldData.entries) ? rawOldData.entries : [],
      }
    : { count: 0, entries: [] };
}




const CustomAccordion = ({ title, children, defaultOpen = true, sx }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Accordion
      expanded={open}
      onChange={() => setOpen(!open)}
      disableGutters
      elevation={3}
      sx={{
        ...sx,
        transition: 'none',
        '&.Mui-expanded': {
          marginBottom: 0, // Only override bottom margin
        },
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" fontWeight="bold">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          transition: 'none',
          visibility: open ? 'visible' : 'hidden',
          height: open ? 'auto' : 0,
          overflow: 'hidden',
          padding: open ? 2 : 0,
        }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );
};



const StatsPage = () => {
  const initialStatsCache = getCachePayload(STATS_PREFETCH_PAGE1_KEY);
  const initialContentCache = getCachePayload(CONTENT_ERRORS_CACHE_KEY);

  const [stats, setStats] = useState(initialStatsCache || null);
  const [loading, setLoading] = useState(!initialStatsCache);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(initialStatsCache?.count || 0);
  const [tabIndex, setTabIndex] = useState(0);
  const [townsWithoutData, setTownsWithoutData] = useState(
    initialContentCache?.towns_without_data || null,
  );
  const [loadingErrors, setLoadingErrors] = useState(false);
  const [townsWithOldData, setTownsWithOldData] = useState(
    normalizeOldData(initialContentCache?.towns_with_old_data),
  );

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const itemsPerPage = 15;

  const fetchStats = async (page = 1) => {
    if (page === 1) {
      const cached = getCachePayload(STATS_PREFETCH_PAGE1_KEY);
      if (cached) {
        setStats(cached);
        setCount(cached?.count || 1);
        setLoading(false);
        return;
      }
    }

    try {
      setLoading(true);
      const res = await axios.get(`${BACKEND_BASE_URL}/api/municipality/stats/?page=${page}`);
      setStats(res.data);
      setCount(res.data?.count || 1);
      if (page === 1) {
        setCachePayload(STATS_PREFETCH_PAGE1_KEY, res.data);
      }
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchTownsWithoutData = async () => {
    const cached = getCachePayload(CONTENT_ERRORS_CACHE_KEY);
    if (cached) {
      setTownsWithoutData(cached?.towns_without_data || {});
      setTownsWithOldData(normalizeOldData(cached?.towns_with_old_data));
      setLoadingErrors(false);
      return;
    }

    try {
      setLoadingErrors(true);
      const res = await axios.get(`${BACKEND_BASE_URL}/api/content-error/`);
      setTownsWithoutData(res.data?.towns_without_data || {});
      setTownsWithOldData(normalizeOldData(res.data?.towns_with_old_data));
      setCachePayload(CONTENT_ERRORS_CACHE_KEY, res.data);
    } catch (err) {
      console.error('Error fetching towns without data:', err);
    } finally {
      setLoadingErrors(false);
    }
  };

  useEffect(() => {
    fetchStats(page);
  }, [page]);

  useEffect(() => {
    if (tabIndex !== 1) return;
    if (townsWithoutData !== null) return;
    fetchTownsWithoutData();
  }, [tabIndex, townsWithoutData]);

  const handlePageChange = (_, value) => {
    setPage(value);
  };

  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };


  const overall = stats?.results?.overall || {};
  const stateStats = stats?.results?.by_state || [];
  const townsWithoutDataEntries = Array.isArray(townsWithoutData?.entries)
    ? townsWithoutData.entries
    : [];
  const townsWithOldDataEntries = Array.isArray(townsWithOldData?.entries)
    ? townsWithOldData.entries
    : [];

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 3, sm: 5 } }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 4 }}
      >
        <Tab label={<Typography variant={isMobile ? "body1" : "h6"} fontWeight="bold">📊 Stats</Typography>} />
        <Tab label={<Typography variant={isMobile ? "body1" : "h6"} fontWeight="bold">❌ Content Errors</Typography>} />
      </Tabs>

      {/* 📊 Stats Tab */}
      {tabIndex === 0 && (
        <>
          {loading || !stats ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
              <CircularProgress size={50} />
            </Box>
          ) : (
            <>
              <Card elevation={3} sx={{ borderRadius: 4, mb: 4 }}>
                <CardContent>
                  <Typography
                    variant="h5"
                    fontWeight="medium"
                    sx={{ fontSize: { xs: '1.3rem', sm: '1.5rem' } }}
                  >
                    👤 User Count: {(overall.total_users ?? 0).toLocaleString()}
                  </Typography>
                </CardContent>
              </Card>

              <Card elevation={3} sx={{ borderRadius: 4, mb: 4 }}>
                <CardContent>
                  <Typography
                    variant="h5"
                    fontWeight="medium"
                    sx={{ fontSize: { xs: '1.2rem', sm: '1.4rem' }, mb: 2 }}
                  >
                    🌍 User Breakdown by Country
                  </Typography>

                  <Grid container spacing={2}>
                    {stats?.results?.country_breakdown?.map((country, index) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Typography variant="body1">
                          {country.name}: <strong>{country.user_count.toLocaleString()}</strong>
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>


              <Typography variant="h5" fontWeight="bold" gutterBottom>
                📦 Platform Totals:
              </Typography>

              <Card elevation={3} sx={{ borderRadius: 4, mb: 5 }}>
                <CardContent>
                  <Grid container spacing={2}>
                    {[
                      { label: '🏙️ Total towns', value: overall.total_towns },
                      { label: '🏞️ Total counties', value: overall.total_counties },
                      { label: '🏛️ Total Town Governments', value: overall.total_town_governments },
                      { label: '🏫 Total School Boards', value: overall.total_school_boards },
                      { label: '🏛️ Total town meetings', value: overall.total_town_meetings },
                      { label: '🏫 Total BoE meetings', value: overall.total_boe_meetings },
                      { label: '👥 Total population', value: overall.total_population }
                    ].map((item, i) => (
                      <Grid item xs={12} sm={6} key={i}>
                        <Typography>
                          {item.label}: {(item.value ?? 0).toLocaleString()}
                        </Typography>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>

              <Typography variant="h5" fontWeight="bold" gutterBottom>
                🗺️ Breakdown by State/Country:
              </Typography>

              <Grid container spacing={2}>
                {stateStats.map((state, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <Card elevation={2} sx={{ borderRadius: 3, height: '100%' }}>
                      <CardContent>
                        <Typography variant="h6" fontWeight="bold" gutterBottom>
                          {state.state}
                        </Typography>
                        <Typography>Towns: {(state.total_towns ?? 0).toLocaleString()}</Typography>
                        <Typography>Counties: {(state.total_counties ?? 0).toLocaleString()}</Typography>
                        <Typography>Town Governments: {(state.total_town_governments ?? 0).toLocaleString()}</Typography>
                        <Typography>School Boards: {(state.total_school_boards ?? 0).toLocaleString()}</Typography>
                        <Typography>Town Meetings: {(state.total_town_meetings ?? 0).toLocaleString()}</Typography>
                        <Typography>BOE Meetings: {(state.total_boe_meetings ?? 0).toLocaleString()}</Typography>
                        <Typography>Population: {(state.total_population ?? 0).toLocaleString()}</Typography>
                      </CardContent>
                    </Card>

                  </Grid>
                ))}
              </Grid>

              <Box mt={4} display="flex" justifyContent="center">
                <Pagination
                  count={Math.ceil(count / itemsPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  shape="rounded"
                  size={isMobile ? 'medium' : 'large'}
                />
              </Box>
            </>
          )}
        </>
      )}

      {/* ❌ Content Errors Tab */}
      {tabIndex === 1 && (
        <>
          {loadingErrors ? (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
              <CircularProgress size={50} />
            </Box>
          ) : (
            <>
              <CustomAccordion title={`❗ Towns Without Data (${townsWithoutData?.count || 0})`}>
                {townsWithoutDataEntries.map((entry) => (
                  <Box key={entry.id} sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      fontWeight="medium"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        sessionStorage.setItem('channel_urls', JSON.stringify([entry.channel_url]));
                        sessionStorage.setItem('state', entry.state);
                        sessionStorage.setItem('county', entry.county);
                        window.open(`/app/manage?search=${encodeURIComponent(entry.name)}`, '_blank');
                      }}
                    >
                      {entry.name}, {entry.county}, {entry.state}, ({entry.id})
                    </Typography>

                    <Box sx={{ ml: 2, mt: 1 }}>
                      <Typography variant="body2">Channel:</Typography>
                      <a
                        href={entry.channel_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-word' }}
                      >
                        {entry.channel_url}
                      </a>
                    </Box>
                  </Box>
                ))}
              </CustomAccordion>

              <CustomAccordion
                title={`🕒 Towns With Data Older Than 60 Days (${townsWithOldData?.count || 0})`}
                sx={{ mt: 3 }}
              >
                {townsWithOldDataEntries.map((entry) => (
                  <Box key={entry.id} sx={{ mb: 2 }}>
                    <Typography
                      variant="body1"
                      fontWeight="medium"
                      sx={{ cursor: 'pointer' }}
                      onClick={() => {
                        sessionStorage.setItem('channel_urls', JSON.stringify([entry.channel_url]));
                        sessionStorage.setItem('state', entry.state);
                        sessionStorage.setItem('county', entry.county);
                        window.open(`/app/manage?search=${encodeURIComponent(entry.name)}`, '_blank');
                      }}
                    >
                      {entry.name}, {entry.county}, {entry.state}, ({entry.id})
                    </Typography>

                    <Box sx={{ ml: 2, mt: 1 }}>
                      <Typography variant="body2">Channel:</Typography>
                      <a
                        href={entry.channel_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-word' }}
                      >
                        {entry.channel_url}
                      </a>
                    </Box>
                  </Box>
                ))}
              </CustomAccordion>


            </>
          )}
        </>
      )}
    </Container>
  );
};

export default StatsPage;

